import { render, staticRenderFns } from "./BarcodeDecoder.vue?vue&type=template&id=3801a7f6&scoped=true"
import script from "./BarcodeDecoder.vue?vue&type=script&lang=js"
export * from "./BarcodeDecoder.vue?vue&type=script&lang=js"
import style0 from "./BarcodeDecoder.vue?vue&type=style&index=0&id=3801a7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801a7f6",
  null
  
)

export default component.exports